module.exports = __webpack_public_path__ + "static/not-found-fa8e2733057418b198f35afea68886bd.svg";